import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import IdfLoginBlockData from '../../../Models/Content/IdfSaleBlockData';
import IdfLogin from './IdfLogin';

export default class IdfLoginBlock extends EpiComponent<IdfLoginBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <IdfLogin context={this.getContext()} contentData={this.props.data} />;
  }
}
